import React from 'react';
import { Flex, Grid, Logo, Modal, Progress } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import Gradient from 'components/Gradient/Gradient';
import { token } from '@landr/styled-system/tokens';
import { DeviceCodeAuthorizationStep } from './types';
import { StartDeviceAuthenticationStep } from './components/StartDeviceAuthorizationStep';
import { DisplayDeviceCodeStep } from './components/DisplayDeviceCodeStep';
import { useDeviceCodeAuthorization } from './useDeviceCodeAuthorization';

export const DeviceCodeAuthorizationModal: React.FC = () => {
    const {
        cancel,
        deviceAuthorizationCode,
        deviceAuthorizationUrl,
        isDeviceAuthorizationOpen,
        startDeviceAuthorization,
        step,
    } = useDeviceCodeAuthorization();

    return (
        <>
            <Modal
                isOpen={isDeviceAuthorizationOpen}
                size="full"
                isDismissible={false}
                zIndex={token('zIndex.absoluteTop')}
                isFull // even though it's deprecated, it's still required for a full screen modal
                className={css({
                    backgroundColor: 'transparent',
                    border: 'none',
                    margin: 0,
                    maxWidth: 'initial',
                })}
            >
                <Gradient
                    color="colors.primary.600"
                    opacity="subtle"
                    height="3/4"
                />
                <Modal.Content>
                    <Modal.Section height="100%">
                        <Grid columns={1} height="100%">
                            <Grid.Item>
                                <Flex justifyContent="center">
                                    <Logo variant="brand" />
                                </Flex>
                            </Grid.Item>
                            <Grid.Item>
                                {step ===
                                    DeviceCodeAuthorizationStep.WaitingToStart && (
                                    <Flex justifyContent="center">
                                        <Progress size="lg" />
                                    </Flex>
                                )}
                                {step ===
                                    DeviceCodeAuthorizationStep.StartDeviceAuthorization && (
                                    <StartDeviceAuthenticationStep
                                        startDeviceAuthorization={
                                            startDeviceAuthorization
                                        }
                                    />
                                )}
                                {deviceAuthorizationCode &&
                                    deviceAuthorizationUrl &&
                                    step ===
                                        DeviceCodeAuthorizationStep.DeviceCodeAuthorization && (
                                        <DisplayDeviceCodeStep
                                            deviceAuthorizationUrl={
                                                deviceAuthorizationUrl
                                            }
                                            deviceCode={deviceAuthorizationCode}
                                            onCancel={cancel}
                                        />
                                    )}
                            </Grid.Item>
                        </Grid>
                    </Modal.Section>
                </Modal.Content>
            </Modal>
        </>
    );
};
